import axios from 'axios';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// api
import BaseApi from '../api/BaseApi';
// components
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import SmallLoading from '../element/SmallLoading';
import { addBreadcrumbSchema } from '../helpers';

const SearchByRegion = () => {
  const location = useLocation();
  const { t } = useTranslation('global');

  const decodeKeyword = encodedKeyword => decodeURIComponent(encodedKeyword);

  const [loading, setLoading] = useState(true);
  const [regionsData, setRegionsData] = useState([]);
  const [lettersData, setLettersData] = useState([]);
  const [smallLoading, setSmallLoading] = useState(false);
  const [formTabs, setFormTabs] = useState(location.pathname === '/search-by-regions' ? 1 : 2);

  useEffect(() => {
    const getData = async () => {
      try {
        if (formTabs === 1) {
          setSmallLoading(true);

          const response = await axios.post(BaseApi + '/jobs/by-regions');

          setSmallLoading(false);
          setRegionsData(response.data.response);
        } else if (formTabs === 2) {
          setSmallLoading(true);

          const response = await axios.post(BaseApi + '/jobs/by-letters');

          setSmallLoading(false);
          setLettersData(response.data.response);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        setSmallLoading(false);

        console.error('Error fetching data', error);
      }
    };

    getData();
  }, [formTabs]);

  useEffect(() => {
    const metaTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaTitle) {
      metaTitle.textContent = t('searchJobPage.metaTitleValue');
    }

    if (metaDescription) {
      metaDescription.content = t('searchJobPage.metaDescriptionValue');
    }

    window.scrollTo(0, 0);
  }, [t]);

  useEffect(() => {
    const canonicalUrl = `${window.location.origin}${location.pathname}`;

    let linkElement = document.querySelector('link[rel="canonical"]');

    if (linkElement) {
      linkElement.setAttribute('href', canonicalUrl);
    } else {
      linkElement = document.createElement('link');
      linkElement.setAttribute('rel', 'canonical');
      linkElement.setAttribute('href', canonicalUrl);
      document.head.appendChild(linkElement);
    }

    const breadcrumbs = [
      { name: t('searchByRegion.searchJobsByRegions') },
    ];

    const script = addBreadcrumbSchema(breadcrumbs);

    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [location.pathname, t]);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      const element = document.getElementById(decodeKeyword(hash));

      if (element) {
        const yOffset = -100;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [location, regionsData]);

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='aboutusSection1 text-center'>
                <h1>
                  {t('searchByRegion.searchJobsByRegions')}
                </h1>
                <h6 className='text-muted fw-normal text-center'>
                  <Link to='/' style={{ color: 'grey' }}>
                    {t('navHeaders.home')}
                  </Link>
                  {' / '}
                  {t('searchByRegion.searchJobsByRegions')}
                </h6>
              </div>
              <div className='SJPSection2 container'>
                <div className='FBitem'>
                  <div className='mb-4 formTabs'>
                    <Link to='/search-by-regions'>
                      <button
                        type='button'
                        style={{ width: '150px' }}
                        className={`btn button2 ${formTabs === 1 && 'active'}`}
                        onClick={() => {
                          setFormTabs(1);
                          setLettersData([]);
                        }}
                      >
                        {t('searchByRegion.byRegions')}
                      </button>
                    </Link>
                    <Link to='/search-by-cities'>
                      <button
                        type='button'
                        style={{ width: '150px' }}
                        className={`btn button2 ${formTabs === 2 && 'active'}`}
                        onClick={() => {
                          setFormTabs(2);
                          setRegionsData([]);
                        }}
                      >
                        {t('searchByRegion.byCity')}
                      </button>
                    </Link>
                  </div>
                  <div style={{ minHeight: '100px' }}>
                    {
                      formTabs === 1 && (
                        smallLoading
                          ? (
                            <div className='text-center'>
                              <SmallLoading />
                            </div>
                          ) : (
                            regionsData?.map(i => (
                              <div key={i.region} className='searchByRegionsBox'>
                                <h2 id={i.region}>{i.region}</h2>
                                <div className='row'>
                                  {
                                    i.cities.map(city => (
                                      <div key={city.name} className='mb-3 mb-md-3 col-md-3'>
                                        <Link to={`/searchjob/r-${city.name}`}>
                                          {city.name}
                                          {city.count != 0 && ` (${city.count})`}
                                        </Link>
                                      </div>
                                    ))
                                  }
                                </div>
                              </div>
                            ))
                          )
                      )
                    }
                    {
                      formTabs === 2 && (
                        smallLoading
                          ? (
                            <div className='text-center'>
                              <SmallLoading />
                            </div>
                          ) : (
                            lettersData
                              ?.sort((a, b) => a.char.localeCompare(b.char))
                              .map(i => (
                                <div key={i.char} className='searchByRegionsBox'>
                                  <h2>{i.char}</h2>
                                  <div className='row'>
                                    {
                                      i.cities.map(city => (
                                        <div key={city.name} className='mb-3 mb-md-3 col-md-3'>
                                          <Link to={`/searchjob/r-${city.name}`}>
                                            {city.name}
                                            {city.count != 0 && ` (${city.count})`}
                                          </Link>
                                        </div>
                                      ))
                                    }
                                  </div>
                                </div>
                              ))
                          )
                      )
                    }
                  </div>
                </div>
              </div>
              <Footer />
            </>
          )
      }
    </>
  );
};

export default SearchByRegion;
